import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";

import firestore from "src/apiService/firestore";

/**
 * Record activity for the current session.
 *
 * - Reseller session: write `Users/{uid}.last_accessed` directly (Firestore
 *   rules allow the owner, and block impersonation sessions from writing it).
 * - Impersonation (accountant) session: call the backend, which updates
 *   `Invitations.accountant_last_accessed` for the (accountant, client) pair —
 *   the client SDK can't write that, and shouldn't touch `Users.last_accessed`.
 */
export async function touchLastAccessedApi(
  isImpersonation: boolean
): Promise<void> {
  if (isImpersonation) {
    const fn = firebase
      .functions()
      .httpsCallable("accountant-touchLastAccessed");
    await fn();
    return;
  }

  const uid = firebase.auth().currentUser?.uid;
  if (!uid) return;
  await firestore().collection("Users").doc(uid).update({
    last_accessed: firebase.firestore.FieldValue.serverTimestamp(),
  });
}
